/**
 * Responsável por fazer as mudanças do 'state'
 */

import * as types from './mutation-types'

export default {
    [types.SET_USER] (state, payload) {
        state.user = payload
    },
    [types.SET_TOKEN] (state, payload) {
        state.token = payload
    },
    [types.INITIALIZATION] (state) {
        // state.token = payload
        console.log('VIVO!')
    }
}
